import { Grid, Typography } from '@mui/material'
import { useUser } from '@/features/auth/hooks/useUser'
import { AffCode } from '../inputs/AffCode'
import { Industries } from '../inputs/Industries'
import { Languages } from '../inputs/Languages'
import { MediaStatus } from '../inputs/MediaStatus'
import { MediaType } from '../inputs/MediaType'
import { ModifiedFromDate, ModifiedToDate } from '../inputs/ModifiedDate'
import { ProductId } from '../inputs/ProductId'
import { Providers } from '../inputs/Providers'
import { SecuredFromDate, SecuredToDate } from '../inputs/SecureDate'

export const MediaDetails = () => {
  const {
    selectors: { selectUserRights },
  } = useUser()
  const { canViewProvider } = selectUserRights()
  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography variant="h2">Media Details</Typography>
      </Grid>
      <Grid size={12}>
        <MediaType />
      </Grid>
      <Grid size={12}>
        <Industries />
      </Grid>
      <Grid size={12}>
        <MediaStatus />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <ModifiedFromDate />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <ModifiedToDate />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <SecuredFromDate />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <SecuredToDate />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 'grow' }}>
        <Languages />
      </Grid>
      {canViewProvider && (
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <Providers />
        </Grid>
      )}
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <AffCode />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <ProductId />
      </Grid>
    </Grid>
  )
}
